import { phone } from 'phone';

export const verifyMobileNumber = (countryCode: string, mobile: string): boolean => {
  const mobileWithCountryCode = `${countryCode}${mobile}`;
  return phone(mobileWithCountryCode).isValid;
};

export const newVerifyMobileNumber = (countryCode: string, mobile: string): boolean => {
  if (countryCode.trim() == '852' || countryCode.trim() == '+852') {
    return new RegExp('^[\\d]{8}$').test(mobile);
  } else {
    return new RegExp('^[\\d]{8,13}$').test(mobile);
  }
};
